<script setup>
  defineProps(['fighter']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <span class="change change-left" :class="{ hidden: fighter.change.value === 'default' }">
    <i :class="fighter.change.value" />
    <span>{{ fighter.steps }}</span>
  </span>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .change {
    display: flex;
    align-items: center;
    gap: px(4);

    width: px(20);

    @include roboto-regular(px(14));
    color: $grey-1;

    i {
      display: block;

      width: 0;
      height: 0;
      border-left: px(4.5) solid transparent;
      border-right: px(4.5) solid transparent;

      border-bottom: px(6) solid $green;

      &.down {
        border-bottom-color: $dark-red;
        transform: rotate(180deg);
      }
    }

    &.hidden {
      visibility: hidden;
    }
  }
</style>
